import { digitGroup } from 'src/helpers'

const initForm = {
  name: null,
  qty: null,
  total: null
}

export default function () {
  return {
    table: {
      list: {
        visibleColumns: ['name', 'total_qty', 'total'],

        columnsproduct: [
          {
            name: 'name',
            label: 'Nama Produk',
            align: 'left',
            field: row => {
              return `
                  <div>${row.product_name}</div>
                  <div class="text-grey-6 text-capitalize" style="font-size: 12px">
                  ${row.variant || '-'}
                  </div>
                `
            },
            format: (val) => val || '-'
          },
          {
            name: 'total_qty',
            field: row => {
              return `
                  <div>${row.jumlah_pembelian}</div>
                  <div class="text-grey-6 text-capitalize" style="font-size: 12px">
                  ${row.uom || '-'}
                  </div>
                `
            },
            label: 'Jumlah',
            align: 'right',
            rowClass: 'text-right',
            format: (val) => val || '-'
          },

          {
            name: 'total',
            label: 'Total Pembelian',
            field: (row) => {
              return 'Rp ' + digitGroup(row.total_pembelian) || '-'
            },
            align: 'right',
            rowClass: 'text-right',
            format: (val) => val || '-'
          }
        ],

        columnscustomer: [
          {
            name: 'name',
            label: 'Nama Customer',
            align: 'left',
            field: (row) => {
              return row.name || '-'
            },
            format: (val) => val || '-'
          },
          {
            name: 'total_qty',
            field: (row) => {
              return row.jumlah_pembelian || '-'
            },
            label: 'Jumlah Pembelian',
            align: 'right',
            rowClass: 'text-right',
            format: (val) => val || '-'
          },

          {
            name: 'total',
            label: 'Total Pembelian',
            field: (row) => {
              return 'Rp ' + digitGroup(row.total_pembelian) || '-'
            },
            align: 'right',
            rowClass: 'text-right',
            format: (val) => val || '-'
          }
        ],

        columnsvendor: [
          {
            name: 'name',
            label: 'Nama Vendor',
            align: 'left',
            field: (row) => {
              return row.name || '-'
            },
            format: (val) => val || '-'
          },
          {
            name: 'total_qty',
            label: 'Jumlah Transaksi',
            field: (row) => {
              return row.jumlah_transaksi || '-'
            },
            align: 'right',
            rowClass: 'text-right',
            format: (val) => val || '-'
          },

          {
            name: 'total',
            label: 'Total Transaksi',
            field: (row) => {
              return 'Rp ' + digitGroup(row.total_transaksi) || '-'
            },
            align: 'right',
            rowClass: 'text-right',
            format: (val) => val || '-'
          }
        ],

        filterResponse: {},
        selectedRow: [],
        fetchedData: null,

        variantType: {
          value: null
        },

        formDefault: JSON.parse(JSON.stringify(initForm)),
        form: { ...initForm }
      }
    }
  }
}
